import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import { Row, Col, Alert, Card, CardBody, Container, Input } from "reactstrap"

import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

const host = window.location.protocol + "//" + window.location.host;
import Config, { ActiveClient } from "../../config";
var LogoSet = (ActiveClient) ? Config[ActiveClient] : Config["cargills"];
//console.log(LogoSet);

// action

import { Text } from "../../framework/validators/TextValidation"
// import images
import profile from "assets/images/profile-img.png"
//import logo from "assets/images/logo/cargills_GO.png"
//import logo from "assets/images/logo/mySky_GO.png"
var logo;
import(`../../assets/images/logo/${LogoSet.logoLightPng}`).then(data => {
  logo = host + data.default;
});

import { useHistory } from 'react-router-dom';

const ForgetPasswordPage = props => {

  const [strUsername, setUsername] = useState('')
  const [strPassword, setPassword] = useState('')
  const [strNewPassword, setNewPassword] = useState('')
  const [errorColor, setErrorColor] = useState('')
  const [error, setError] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [regexstring, setRegexstring] = useState('')
  const [regexmsg, setRegexmsg] = useState('')
  let history = useHistory();

  useEffect(async () => {
    const ApiURL = window.Links.ApiURL
    if (localStorage.getItem('ui') == null) {
      // window.location.href = "/"
      history.push('/')
    }

    const type = props.location.search.replace('?', '',)
    setUsername(type)

    var authToken = ''

    await fetch(`${ApiURL}login/${type}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(Response => Response.json())
      .then(responseData => {
        authToken = responseData.token
      }).catch(error => {
        console.log(error)
      })



    await fetch(`${ApiURL}common/userpolicy/${type}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    }).then(Response => Response.json())
      .then(responseData => {
        var dt = responseData.data[0]
        setRegexmsg(dt.message)
        setRegexstring(dt.policy)

      }).catch(error => {
        console.log(error)
      })

  }, [])

  async function handleValidSubmit(event, values) {
    // dispatch(userForgetPassword(values, props.history))

    if (regexstring != '') {

      var pattern = new RegExp(regexstring);

      if (!pattern.test(strPassword)) {
        setError(true)
        setErrorMsg(regexmsg)
        setErrorColor('danger')
        return
      }

      if (strPassword !== strNewPassword) {
        setError(true)
        setErrorMsg('Password and confirm password must be same')
        setErrorColor('danger')
        return
      }


    } else {
      if (strPassword.length < 4) {
        setError(true)
        setErrorMsg('Password must be 8 characters long')
        setErrorColor('danger')
        return
      }

      if (strPassword !== strNewPassword) {
        setError(true)
        setErrorMsg('Password and confirm password must be same')
        setErrorColor('danger')
        return
      }

    }



    const ApiURL = window.Links.ApiURL

    // SetLoadingAlert(true)
    // SetLoadingAlerttitle("Updating...")

    var authToken = ''

    await fetch(`${ApiURL}login/${strUsername}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(Response => Response.json())
      .then(responseData => {
        authToken = responseData.token
      }).catch(error => {
        console.log(error)
      })

    var location = ''
    var company = ''

    // await fetch(`${ApiURL}forgot-password`, {
    //   method: "GET",
    //   headers: {
    //     "Content-Type": "application/json",
    //     "Authorization": `Bearer ${authToken}`
    //   },
    // }).then(Response => Response.json())
    //   .then(responseData => {
    //     var dt = responseData.data[0]
    //     location = dt.locationcode
    //     company = dt.companycode

    //   }).catch(error => {
    //     console.log(error)
    //   })

    const menucode = 'M0999'

    const passwordReset = {
      "strUserCode": strUsername,
      "strNewPassword": strNewPassword,
      "strMenuCode": menucode,
      "strLoggedLocation": location,
      "strLoggedCompany": company,
      "strReason": 'Password Reset',
      "strCreateBy": strUsername
    }



    fetch(`${ApiURL}User/reset/password`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify(passwordReset)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {
            if (responseData.data == "Current password and new password are same !") {
              setErrorColor('warning')
              setErrorMsg(responseData.data)
              setError(true)
              setTimeout(() => {
                setError(false)
              }, 3000)
            } else {
              setError(true)
              setErrorMsg(responseData.data)
              setErrorColor('success')
              setTimeout(() => {
                setError(false)
                // window.location.href = "/"
                history.push('/')
                localStorage.removeItem('ui')
              }, 3000)
            }
          }
          )
      } else if (Response.status == "400") {
        SetLoadingAlert(false)
        Response.json()
          .then(responseData => {
            //setMyAlertError(responseData.msg)
          })
        setErrorColor('danger')
        setErrorMsg("Error !")
        setError(true)
        setTimeout(() => {
          setError(false)
        }, 3000)
      } else {
        setErrorColor('success')
        setErrorMsg("Success !")
        setError(true)
        setTimeout(() => {
          setError(false)
        }, 3000)
      }
    }).catch(error => {
      console.log(error.message)
    })

    setTimeout(() => {
      setError(false)
    }, 3000)


  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>
          Forget Password
        </title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-softbg-soft-primary">
                  <Row>
                    <Col xs={7}>
                      <div className="text-white p-4">
                        <h5 className="text-white">Enter New Password</h5>
                        <p></p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="70"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {error ? (
                      <Alert color={errorColor ? errorColor : 'danger'} style={{ marginTop: "13px" }}>
                        {errorMsg}
                      </Alert>
                    ) : null}

                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                    >
                      <div className="mb-3">
                        <AvField
                          name="username"
                          label="Username"
                          value={strUsername}
                          className="form-control"
                          placeholder="Enter username"
                          type="username"
                          onChange={(e) => {
                            setUsername(Text(e.target, 10, true, false, "upper", false))
                          }}
                          onBlur={async (e) => {
                            loadLocations(e.target.value)
                          }}
                          disabled={true}

                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          value={strPassword}
                          type="password"
                          required
                          placeholder="Enter New Password"
                          onChange={(e) => {
                            let val2 = Text(e.target,
                              15,
                              true,
                              true,
                              "normal",
                              false);
                            console.log(val2)
                            setPassword(val2)
                          }}
                        />
                      </div>
                      {/* 
                      <Input
                        className="form-control-sm"
                        type={'text'}
                        value={strPassword}
                        onChange={(e) => {
                          let val2 = Text(e.target,
                            15,
                            true,
                            true,
                            "normal",
                            false);
                          console.log(val2)
                          setPassword(e.target.value)
                        }}
                       
                      /> */}


                      <div className="mb-3">
                        <AvField
                          name="newpassword"
                          label="Confirm Password"
                          value={strNewPassword}
                          type="password"
                          required
                          placeholder="Confirm New Password"
                          onChange={(e) => {
                            let val2 = Text(e.target,
                              15,
                              true,
                              true,
                              "normal",
                              false);

                            setNewPassword(val2)
                          }}
                        />
                      </div>

                      <Row className="mt-3 d-grid">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-lg "
                            type="submit"
                          >
                            Reset
                          </button>
                        </Col>
                      </Row>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="login" className="font-weight-medium text-primary" onClick={(e) => {
                    localStorage.removeItem('ui')
                  }}>
                    Login
                  </Link>{" "}
                </p>
                <p>
                © {new Date().getFullYear()} <a href={Config[Config.ActiveClient].webUrl}>{Config[Config.ActiveClient].fullName}</a>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
